<div class="wgc-container">
  <wgc-header-main></wgc-header-main>
  <router-outlet></router-outlet>
  <app-footer-main></app-footer-main>
</div>
